import { Link, navigate } from 'gatsby';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React, { useEffect, useState } from 'react';
import SignUpButton from 'src/components/SignUpButton';
import TopBarMenu from 'src/components/TopBar/TopBarMenu';
import Burger from 'src/components/TopBar/burger/Burger';
import DropdownMenu from 'src/components/TopBar/dropdownMenu/DropdownMenu';
import { socialLinks } from 'src/config';
import Analytics from 'src/helpers/analytics';
import {
  JonniLogoBlue,
  LogoContainer,
  PaddingStyled,
  StartBtnContainer,
  TopBarBackground,
  // TopStartBtnContainer,
  TopBarContainer,
  TopBarLeftContainer,
  WhatsappBlueIcon,
  WhatsappContactUsText,
  WhatsappContainerStyled,
} from 'src/styles/topbar';

const signupButtonStyles = { margin: '26px 0 10px 0', borderRadius: '68px', background: '#d7daf1', color: '#162154' };

const TopBar = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isOpenMenu, setIsOpenMenu] = React.useState(false);
  const [background, setBackground] = React.useState(false);
  const { t } = useTranslation();

  const toggleMenu = () => setIsOpenMenu(!isOpenMenu);

  const onAppClick = (name: string) => {
    Analytics.logAppButtonClick(name);
  };

  useEffect(() => {
    window.addEventListener('scroll', listenToScroll);
    return () => window.removeEventListener('scroll', listenToScroll);
  }, []);

  const listenToScroll = () => {
    let buttonHeightToShowFrom = 350;
    let backgroundHeightToShowFrom = 10;
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop;

    if (winScroll > buttonHeightToShowFrom) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }

    if (winScroll > backgroundHeightToShowFrom) {
      setBackground(true);
    } else {
      setBackground(false);
    }
  };

  return (
    <>
      {isVisible && (
        <StartBtnContainer>
          <SignUpButton
            style={signupButtonStyles}
            onClick={() => {
              navigate('/signup');
            }}
            title={t('homePageHeader.signUp')}
          />
        </StartBtnContainer>
      )}
      <TopBarBackground
        style={{
          background: '#FFF',
          boxShadow: background && !isVisible ? '0px 15px 26px 0px rgba(22, 33, 84, 0.04)' : 'none',
        }}>
        <TopBarContainer>
          <Burger isOpen={isOpenMenu} onPress={toggleMenu} />
          <LogoContainer>
            <a href={'https://www.' + process.env.GATSBY_JONNI_DOMAIN}>
              <JonniLogoBlue />
            </a>
          </LogoContainer>

          <TopBarMenu />

          <TopBarLeftContainer>
            <WhatsappContainerStyled>
              <a onClick={() => onAppClick('whatsapp')} href={socialLinks.whatsapp} target="_blank" rel="noreferrer">
                <WhatsappContactUsText>{t('whatsappContact')}</WhatsappContactUsText>
                <WhatsappBlueIcon />
              </a>
            </WhatsappContainerStyled>
          </TopBarLeftContainer>
        </TopBarContainer>
      </TopBarBackground>
      <PaddingStyled />

      <DropdownMenu isOpen={isOpenMenu} onCloseMenu={toggleMenu} />
    </>
  );
};

export default TopBar;
